import React from 'react';

export const SeriesCardLazy = React.lazy(() => import('./SeriesCard'));
